import request from '../../../helpers/request';

export const previewFlatsGridByFile = ({ houseId, file }, extraConfig) => {
  const formData = new FormData();
  formData.append('file', file);

  return request.put(
    `/FlatsGrid/house/${houseId}/preview_grid`,
    formData,
    'Произошла ошибка: файл содержит ошибки',
    null,
    null,
    null,
    extraConfig,
  );
};

export const uploadFlatsGridByFile = ({ houseId, file }) => {
  const formData = new FormData();
  formData.append('file', file);

  return request.put(
    `/FlatsGrid/house/${houseId}/upload_grid`,
    formData,
    'Произошла ошибка: файл содержит ошибки',
  );
};

export const getFlatsGridTemplates = () => {
  return request.get('/FlatsGrid/templates');
};

export const getFlatsGridTemplateById = (id) => {
  return request.get(`/FlatsGrid/template/${id}`);
};

export const downloadFlatsGridTemplate = async ({ id, fileName }) => {
  const responseData = await getFlatsGridTemplateById(id);

  const data = Buffer.from(responseData, 'base64');
  const url = URL.createObjectURL(new Blob([data]));

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);

  return responseData;
};
